import React, { useState, useEffect, useContext, useMemo } from 'react';
import { BsFillChatQuoteFill } from 'react-icons/bs';
import { GoPerson } from 'react-icons/go';
import { MdDeleteForever } from 'react-icons/md';
import { FcCheckmark } from 'react-icons/fc';
import { updateMessage } from '../../firebase/firebase';

import './message-details.css';
import { lists } from '../../util/constants';

const MessageDetails = (props: any) => {

   const color = useMemo<string>(() => getUserColor(), []);


   function getPtDate(dateValue: number) : string {
      const date = new Date(dateValue);
      const months = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul', 'Ago','Set','Out','Nov','Dez'];

      return `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`;
   }

   function getEnDate(dateValue: number) : string {
      const date = new Date(dateValue);
      return date.toDateString();
   }


   function updateMessageStatus(newStatus: string) {
      updateMessage(props.msg, newStatus);
      props.forceUpdate();
   }
   
   return (
      <div className='ml-message'>
         <div className='ml-m-user d-flex'>
            {
               props.currentList &&
               <div className='ml-m-actions d-flex'>
                  {
                     (props.currentList === lists.unchecked || props.currentList === lists.deleted) &&
                     <div 
                        className='ml-m-action d-flex justify-content-center align-items-center'
                        style={props.currentList === lists.unchecked ? {marginRight: '.5rem'} : {}}
                        onClick={() => updateMessageStatus(lists.approved)}   
                     >
                        <FcCheckmark />
                     </div>
                  }
                  {
                     (props.currentList === lists.unchecked || props.currentList === lists.approved) && 
                     <div 
                        className='ml-m-action ml-m-action-delete d-flex justify-content-center align-items-center'
                        onClick={() => updateMessageStatus(lists.deleted)}
                     >
                        <MdDeleteForever />
                     </div>
                  }
               </div>
            }
            <div 
               className='ml-m-icons d-flex justify-content-center align-items-center'
               style={{backgroundColor: color}}   
            >
               <div className='ml-m-icons d-flex justify-content-center align-items-center'>
                  <div className='ml-m-icon ml-m-icon1'><GoPerson/></div>
                  <div className='ml-m-icon ml-m-icon2'><BsFillChatQuoteFill/></div>
               </div>
            </div>
            <div className='ml-m-name d-flex align-items-center'>{props.msg.name}</div>
         </div>
         <div className='ml-m-message'>{props.msg.message}</div>
         <div className='ml-m-date'>{props.language === props.lang.pt ? getPtDate(props.msg.date) : getEnDate(props.msg.date)}</div>
      </div>
   )
}
   

function getUserColor() : string {
   const random = Math.ceil(Math.random() * 12);
   switch (random) {
      case 1:
         return '#D72638';
      case 2:
         return '#79B473';
      case 3:
         return '#E6871A';
      case 4:
         return '#02394A';
      case 5:
         return '#11151C';
      case 6:
         return '#4C0061';
      case 7:
         return '#065143';
      case 8:
         return '#373F51';
      case 9:
         return '#61D9D5';
      case 10:
         return '#453823';
      case 11:
         return '#4e88b1';
      case 12:
         return '#a42567';
      default:
         return '#666';
   }
}

export default MessageDetails
